import React from 'react';
import styled, { css } from 'styled-components';

const StatusTag = styled.div`
  padding: 4px 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  
  ${(props) => props.$isOnline ? css`
    color: #3ED57D;
    background-color: rgba(62, 213, 125, 0.1);
    border: 1px solid rgba(62, 213, 125, 0.3);
  ` : css`
    color: #808080;
    background-color: rgba(128, 128, 128, 0.1);
    border: 1px solid rgba(128, 128, 128, 0.2);
  `}
`;

const Text = styled.span`
  display: block;
  font-size: 11px;
  font-weight: 400;
`;

const ImavenOnlineStatus = ({ isOnline }) => {
    return (
        <StatusTag $isOnline={isOnline}>
            <Text>{isOnline ? 'Online' : 'Offline'}</Text>
        </StatusTag>
    );
};

export default ImavenOnlineStatus;